// extracted by mini-css-extract-plugin
module.exports = {"contexts":"contexts___10dYL","pagination":"pagination___1kMBx"};